<div class="spt-download-spout-container">
  <h1 style="font-weight: bold;">
    Download the Spout desktop application
  </h1>
   <spt-download-spout [showBackground]="false"></spt-download-spout>
</div>